import React, { useEffect, useState, useRef } from "react";

import logo from "../../../images/logo-transparent.png";
import { connect } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import moment from "moment";
import {
    getBookingById,
    getUserDetails,
} from "../../actions/OffLineSupportActions";
import ReactToPrint from "react-to-print";
import Modal from "@mui/material/Modal";
import { useWindowSize } from "../../../utils/hooks/useWindowSize";
import smallLoader from "../Loader80/loader.gif";
import QRCode from "react-qr-code";
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import LanguageIcon from '@mui/icons-material/Language';
import ThumbDownIcon from '@mui/icons-material/ThumbDown';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import './invoice.css'


type PropsCR = {
    openNewInvoiceModal: any;
    setNewInvoiceModal: any;
    id: any;
    booking: any;
    getBookingById: any;
    invoiceLoader: boolean;
    centerInfo: any;
    newInvoiceDetails: any;
    getUserDetails: any
    userDetails: any;
};

const InvoiceTemplate: React.FC<PropsCR> = ({
    booking,
    id,
    getBookingById,
    openNewInvoiceModal,
    setNewInvoiceModal,
    invoiceLoader,
    centerInfo,
    newInvoiceDetails,
    getUserDetails,
    userDetails,
}) => {
    const emptyInvoiceData = {
        bId: "",
        iDate: "",
        cDate: "",
        cName: "",
        cAge: "",
        cAgeDob: "",
        cAddr: "",
        packages: [],
        additionalMembers: [],
        totalPrice: "",
        totalDiscount: "",
        diagnosticCharge: "",
        centre: "",
        centreAddr: "",
        payment: [],
        refDoctor: "",
        billBy: "",
        customer_email: "",
        customer_address: "",
        diagnostic_fee_amount: "",
        total_price_package: "",
        counpon_discount: "",
    };
    const history = useHistory();
    const [cghsclient, setCghsclient] = useState<boolean>(false);
    const [data, setData] = useState<any>(emptyInvoiceData);
    const [paid, setPaid] = useState<any>("");
    const [windowWidth, windowHeight] = useWindowSize();
    const [totalSum, setTotalSum] = useState<any>(0);

    const price_in_words = (price: any) => {
        let sglDigit = [
            "Zero",
            "One",
            "Two",
            "Three",
            "Four",
            "Five",
            "Six",
            "Seven",
            "Eight",
            "Nine",
        ],
            dblDigit = [
                "Ten",
                "Eleven",
                "Twelve",
                "Thirteen",
                "Fourteen",
                "Fifteen",
                "Sixteen",
                "Seventeen",
                "Eighteen",
                "Nineteen",
            ],
            tensPlace = [
                "",
                "Ten",
                "Twenty",
                "Thirty",
                "Forty",
                "Fifty",
                "Sixty",
                "Seventy",
                "Eighty",
                "Ninety",
            ],
            handle_tens = function (dgt: number, prevDgt: number) {
                return 0 == dgt
                    ? ""
                    : " " + (1 == dgt ? dblDigit[prevDgt] : tensPlace[dgt]);
            },
            handle_utlc = function (dgt: number, nxtDgt: number, denom: string) {
                return (
                    (0 != dgt && 1 != nxtDgt ? " " + sglDigit[dgt] : "") +
                    (0 != nxtDgt || dgt > 0 ? " " + denom : "")
                );
            };

        let str = "";
        let digitIdx: number = 0;
        let digit: number;
        let nxtDigit: number = 0;
        let words = [];
        if (price === 0) {
            return "Zero";
        }
        if (((price += ""), isNaN(parseInt(price)))) str = "";
        else if (parseInt(price) > 0 && price.length <= 10) {
            for (digitIdx = price.length - 1; digitIdx >= 0; digitIdx--)
                switch (
                ((digit = price[digitIdx] - 0),
                    (nxtDigit = digitIdx > 0 ? price[digitIdx - 1] - 0 : 0),
                    price.length - digitIdx - 1)
                ) {
                    case 0:
                        words.push(handle_utlc(digit, nxtDigit, ""));
                        break;
                    case 1:
                        words.push(handle_tens(digit, price[digitIdx + 1]));
                        break;
                    case 2:
                        words.push(
                            0 != digit
                                ? " " +
                                sglDigit[digit] +
                                " Hundred" +
                                (0 != price[digitIdx + 1] && 0 != price[digitIdx + 2]
                                    ? " and"
                                    : "")
                                : ""
                        );
                        break;
                    case 3:
                        words.push(handle_utlc(digit, nxtDigit, "Thousand"));
                        break;
                    case 4:
                        words.push(handle_tens(digit, price[digitIdx + 1]));
                        break;
                    case 5:
                        words.push(handle_utlc(digit, nxtDigit, "Lakh"));
                        break;
                    case 6:
                        words.push(handle_tens(digit, price[digitIdx + 1]));
                        break;
                    case 7:
                        words.push(handle_utlc(digit, nxtDigit, "Crore"));
                        break;
                    case 8:
                        words.push(handle_tens(digit, price[digitIdx + 1]));
                        break;
                    case 9:
                        words.push(
                            0 != digit
                                ? " " +
                                sglDigit[digit] +
                                " Hundred" +
                                (0 != price[digitIdx + 1] || 0 != price[digitIdx + 2]
                                    ? " and"
                                    : " Crore")
                                : ""
                        );
                }
            str = words.reverse().join("");
        } else str = "";
        return str;
    };
    const addPrice = (data: any) => {
        let add: number = 0;
        data.length > 0 &&
            data.map((val: any) => {
                if (val.link_type !== "link") {
                    add = add + val.amount;
                    setPaid(add);
                }
            });
    };
    useEffect(() => {
        getUserDetails()
    }, [])
    useEffect(() => {
        if (id) {
            setData(emptyInvoiceData);
            setPaid("");
            setTotalSum(0);
            getBookingById(id);
        }
    }, [id]);

    useEffect(() => {
        if (centerInfo && centerInfo?.results?.length > 0) {
            if (centerInfo?.results[0]?.is_cghs_client === true) {
                setCghsclient(true);
            } else {
                setCghsclient(false);
            }
        }
    }, [centerInfo]);

    console.log("centerInfo", centerInfo)
    console.log(userDetails, "userDetailsuserDetails")

    const currentBookingId = booking?.id === undefined ? booking?.pk : booking?.id;
    const isCurrentBookingLoaded = Number(currentBookingId) === Number(id);


    const [custEmail, setCustEmail] = useState<any>("");
    useEffect(() => {
        if (Object.keys(booking).length !== 0) {
            setData({
                bId: booking?.id === undefined ? booking?.pk : booking?.id,
                iDate: booking?.source_type === "cc-homedx" ? moment(booking?.collection_date).format("DD MMM,YYYY") : moment(booking?.created_at).format("DD MMM,YYYY"),

                cAge: booking?.customer_age,
                cAgeDob: booking?.dob,
                cName: booking?.designation + " " + booking?.customer_name,
                cAddr:
                    (booking?.customer_areapincode?.area === undefined
                        ? " "
                        : booking?.customer_areapincode?.area + ",") +
                    (booking?.customer_areapincode?.city_name === undefined
                        ? " "
                        : booking?.customer_areapincode?.city_name + ", ") +
                    (booking?.customer_areapincode?.pincode === undefined
                        ? " "
                        : "Pin-Code:" + booking?.customer_areapincode?.pincode),
                packages: booking?.packages,
                additionalMembers: booking?.additional_members,
                centre: booking?.centre_address?.name,
                centreAddr:
                    booking?.centre_address !== undefined
                        ? booking?.centre_address?.address
                        : "",
                totalPrice: booking?.final_packages_price,
                totalDiscount: booking?.final_discount,
                diagnosticCharge: booking?.cc_booking_diagnostic_fee_amount,
                payment: booking?.payment_links || [],
                refDoctor: booking?.ref_doctor?.name,
                billBy: booking?.agent?.name,
                customer_email: booking?.customer_email,
                uuid: booking?.uuid,
                bookingType: booking?.booking_type,
                customer_address: booking?.booking_full_address,
                diagnostic_fee_amount: booking?.cc_booking_diagnostic_fee_amount,
                total_price_package: booking?.discounted_price?.total_price_package,
                counpon_discount: booking?.discounted_price?.counpon_discount,
                paymentMode: booking?.payment_links[0]?.link_type,

            });
            setTotalSum(
                booking?.payment_links?.reduce((sum: any, item: any) => sum + item.amount, 0)
            );
            addPrice(booking?.payment_links || []);
        }
    }, [booking]);

    const printFileTitle = `${booking?.customer_name}`;
    const componentRef = useRef<any>(null);
    const reactToPrintContent = React.useCallback(() => {
        return componentRef.current;
    }, [componentRef.current]);
    const reactToPrintTrigger = React.useCallback(() => {
        return <button>Print Receipt</button>;
    }, []);

    const handleDOBForAge = (dob: any, bdate: any) => {
        const a: any = moment(bdate);
        const b: any = moment(dob);
        var years = a.diff(b, "year");
        b.add(years, "years");
        var months = a.diff(b, "months");
        b.add(months, "months");
        var days = a.diff(b, "days");
        if (months !== 0) {
            var age = months + "Months " + days + "Days";
        } else {
            var age = days + "Days";
        }

        return age;
    };

    const url = (id: any) => {
        return `https://redcliffelabs.com/bookingfeedback?type=cc_booking_english&booking_id=${data?.bId}&uuid=${data?.uuid}&rating=${id}`;
    };

    return (
        <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            open={openNewInvoiceModal}
            onClose={() => setNewInvoiceModal(false)}
            closeAfterTransition
            slotProps={{
                backdrop: {
                    timeout: 500,
                },
            }}
        >
            <div
                style={{
                    borderRadius: "10px",
                    margin: "20px auto",
                    backgroundColor: "white",
                    width: windowWidth > 450 ? "50%" : "95%",
                    maxHeight: windowWidth > 450 ? "90vh" : "95vh",
                    overflowY: "auto",
                    fontFamily: "Lato, sans-serif",
                }}
            >
                <button
                    style={{
                        width: "120px",
                        borderRadius: "5%",
                        backgroundColor: "#ef5350",
                        color: "white",
                    }}
                    onClick={() => setNewInvoiceModal(false)}
                >
                    {"<< Go Back"}
                </button>
                {/* @ts-ignore */}
                <ReactToPrint
                    documentTitle={printFileTitle}
                    content={reactToPrintContent}
                    trigger={reactToPrintTrigger}
                />

                <div
                    ref={componentRef}
                // style={{
                //     border: "1px solid grey",

                // }}
                >
                    {invoiceLoader || !isCurrentBookingLoaded ? (
                        <div
                            style={{
                                minHeight: "260px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                padding: "24px",
                            }}
                        >
                            <img
                                src={smallLoader}
                                alt="Loading"
                                style={{ width: "140px", height: "140px", objectFit: "contain" }}
                            />
                        </div>
                    ) : (
                        <div style={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "space-between"
                        }}>
                            <meta charSet="UTF-8" style={{ fontFamily: "Helvetica" }} />
                            <meta
                                name="viewport"
                                // content="width=device-width, initial-scale=1.0"
                                style={{ fontFamily: "Helvetica" }}
                            />
                            <title style={{ fontFamily: "Helvetica" }}>Invoice</title>
                            <div
                                className="invoiceContainer"
                                style={{
                                    fontFamily: "Helvetica",
                                    marginInline: "2vw",
                                    marginTop: 0,
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "space-between"

                                }}
                            >
                                <div id="divToPrint" style={{ fontFamily: "Helvetica" }}>
                                    <hr
                                        className="headerLine"
                                        style={{
                                            border: "5px solid rgb(14, 63, 108)",
                                            fontFamily: "Helvetica",
                                            width: "100%",
                                        }}
                                    />
                                    <div
                                        className="logoContainer"
                                        style={{
                                            display: "flex",
                                            justifyContent: "left"
                                        }}
                                    >
                                        <div style={{ width: "50%", textAlign: "left" }}>
                                            {(
                                                userDetails?.profile?.user_types?.includes("MEDICENTER_CC") ||
                                                newInvoiceDetails?.center?.tags?.includes("MED")
                                            ) ? (
                                                <span style={{ fontWeight: 600 }}>Medicenter </span>
                                            ) : (
                                                <img
                                                    className="invoiceImage"
                                                    src={logo}
                                                    style={{ fontFamily: "Helvetica", height: "50px" }}
                                                    alt="logo"
                                                />
                                            )}
                                        </div>



                                        <div style={{ width: "50%" }}>
                                            <h3 style={{ textAlign: "right", fontWeight: "bolder" }}>
                                                Invoice
                                            </h3>
                                        </div>
                                    </div>
                                    <table
                                        className="invoiceSummaryTable"
                                        style={{
                                            borderCollapse: "collapse",
                                            fontFamily: "Helvetica",
                                            fontSize: "16px",
                                            marginTop: "10px",
                                            textAlign: "left",
                                            width: "100%",
                                        }}
                                    >
                                        <tbody>
                                            <tr
                                                style={{
                                                    borderTop: "1px solid grey",
                                                }}
                                            >
                                                <td
                                                    style={{
                                                        fontFamily: "Helvetica",
                                                        padding: ".6rem",
                                                        paddingRight: "1.6rem",
                                                        borderRight: "1px solid grey",
                                                    }}
                                                >
                                                    INVOICE NO.
                                                </td>
                                                <td
                                                    style={{
                                                        fontFamily: "Helvetica",
                                                        padding: ".6rem",
                                                        paddingRight: "1.6rem",
                                                        borderRight: "1px solid grey",
                                                    }}
                                                >
                                                    INVOICE DATE
                                                </td>
                                                <td
                                                    style={{
                                                        fontFamily: "Helvetica",
                                                        padding: ".6rem",
                                                        borderRight: "1px solid grey",
                                                    }}
                                                >
                                                    BOOKING ID
                                                </td>
                                                <td
                                                    style={{
                                                        fontFamily: "Helvetica",
                                                        padding: ".6rem",
                                                        paddingRight: "1.6rem",
                                                    }}
                                                >
                                                    SAMPLE COLLECTION DATE
                                                </td>
                                            </tr>
                                            <tr
                                                style={{
                                                    fontFamily: "Helvetica",
                                                    borderBottom: "1px solid grey",
                                                }}
                                            >
                                                <td
                                                    style={{
                                                        fontFamily: "Helvetica",
                                                        padding: ".6rem",
                                                        paddingRight: "1.6rem",
                                                        borderRight: "1px solid grey",
                                                    }}
                                                >
                                                    <b>{data?.bId}</b>

                                                </td>
                                                <td
                                                    style={{
                                                        fontFamily: "Helvetica",
                                                        padding: ".6rem",
                                                        paddingRight: "1.6rem",
                                                        borderRight: "1px solid grey",
                                                    }}
                                                >
                                                    <b>
                                                        {data?.iDate} &nbsp;
                                                        {cghsclient && booking?.pickup_time
                                                            ? new Date(`1970-01-01T${booking.pickup_time}Z`).toLocaleTimeString("en-US", {
                                                                hour: "2-digit",
                                                                minute: "2-digit",
                                                                hour12: true,
                                                                timeZone: "UTC",
                                                            })
                                                            : ""}
                                                    </b>

                                                </td>
                                                <td
                                                    style={{
                                                        fontFamily: "Helvetica",
                                                        padding: ".6rem",
                                                        borderRight: "1px solid grey",
                                                    }}
                                                >
                                                    <b>{data?.bId}
                                                    </b>

                                                </td>
                                                <td
                                                    style={{
                                                        fontFamily: "Helvetica",
                                                        padding: ".6rem",
                                                    }}
                                                >
                                                    <b>
                                                        {data?.iDate}
                                                    </b>

                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <div
                                        className="invoiceGrid"
                                        style={{
                                            marginTop: "6px",
                                            display: "flex",
                                            backgroundColor: "#f0f8ff",
                                        }}
                                    >
                                        <div style={{ width: "60%" }}>
                                            <span
                                                style={{ display: "flex", color: "rgb(14, 63, 108)", fontSize: "22px" }}
                                            >
                                                <b>BILL FROM</b>
                                            </span>
                                            <span style={{ display: "flex", lineHeight: "2.4", fontSize: "19px" }}>
                                                <span style={{ width: 150, fontSize: "19px" }}>CIN Number:-</span>
                                                <b>U85100UP2021PTC140992</b>
                                            </span>

                                            <span style={{ display: "flex", fontSize: "19px" }}>
                                                <b>
                                                    {data?.centre}
                                                </b>
                                            </span>
                                            <span style={{ display: "flex", fontSize: "19px" }}>
                                                <b>
                                                    {data?.centreAddr}
                                                </b>
                                            </span>
                                            <span style={{ display: "flex", lineHeight: "2.4", fontSize: "19px" }}>
                                                <span style={{ width: 170, fontSize: "19px" }}>Referring Doctor:-</span>
                                                <b>{data?.refDoctor}</b>
                                            </span>

                                        </div>
                                        <div style={{ width: "40%", marginLeft: "5%" }}>
                                            <span
                                                style={{ display: "flex", color: "rgb(14, 63, 108)", fontSize: "22px" }}
                                            >
                                                <b>CUSTOMER DETAILS</b>
                                            </span>
                                            <span style={{ display: "flex", fontSize: "19px" }}>
                                                <b> {data?.cName} - {booking?.customer_age}y/
                                                    {booking.customer_gender === "male" ? "M" : "F"}</b>
                                            </span>

                                            <span style={{ display: "flex", fontSize: "19px" }}>
                                                {data?.customer_address || "-"}
                                            </span>
                                        </div>
                                    </div>
                                    <hr style={{ fontFamily: "Helvetica" }} />

                                    <table
                                        className="invoiceSummaryTable"
                                        style={{
                                            borderCollapse: "collapse",
                                            fontFamily: "Helvetica",
                                            fontSize: "16px",
                                            marginTop: "1rem",
                                            textAlign: "left",
                                            width: "100%",
                                        }}
                                    >
                                        <tbody>
                                            <tr
                                                style={{
                                                    backgroundColor: "rgb(238 228 222 / 74%)",
                                                    fontFamily: "Helvetica",
                                                }}
                                            >
                                                <td
                                                    style={{
                                                        fontFamily: "Helvetica",
                                                        padding: ".6rem",
                                                        paddingRight: "1.6rem",
                                                    }}
                                                >
                                                    <b>TEST DESCRIPTION</b>
                                                </td>
                                                <td
                                                    style={{
                                                        fontFamily: "Helvetica",
                                                        padding: ".6rem",
                                                        display: "flex", justifyContent: "end"
                                                    }}
                                                >
                                                    <b>Amount</b>
                                                </td>
                                            </tr>

                                            {data.packages?.map((pack: any) => (
                                                <tr
                                                    style={{
                                                        backgroundColor: "#f9f9f9",
                                                        fontFamily: "Helvetica",
                                                    }}
                                                >
                                                    <td
                                                        style={{
                                                            fontFamily: "Helvetica",
                                                            padding: ".6rem",
                                                            paddingRight: "1.6rem",
                                                        }}
                                                    >
                                                        {cghsclient ? pack?.cghs_id ?? "-" : pack.code} - {pack.name}
                                                    </td>
                                                    <td
                                                        style={{
                                                            fontFamily: "Helvetica",
                                                            padding: ".6rem",
                                                            display: "flex", justifyContent: "end"
                                                        }}
                                                    >
                                                        <b>₹{pack.price}</b>

                                                    </td>
                                                </tr>
                                            ))}

                                            {/* {data.additionalMembers && data.additionalMembers?.map((member: any) => (
                        member.ccpackages && member.ccpackages.length > 0 && (

                          <div style={{ margin: "10px 0px"}}>
                            <b style={{ margin: "20px 10px" }}>
                              {member.customer_name} - {member.customer_age}y/
                              {member.customer_gender.charAt(0).toUpperCase()}
                            </b>
                            {
                              member.ccpackages.map((pack: any) => (
                                <tr
                                  style={{
                                    // backgroundColor: "#fff",
                                    fontFamily: "Helvetica",
                                  }}
                                >
                                  <td
                                    style={{
                                      fontFamily: "Helvetica",
                                      padding: ".6rem",
                                      paddingRight: "1.6rem",
                                    }}
                                  >
                                    {pack.code} - {pack.name}
                                  </td>
                                  <td
                                    style={{
                                      fontFamily: "Helvetica",
                                      padding: ".6rem",
                                      display: "flex", justifyContent: "end"
                                    }}
                                  >
                                    <b>₹{pack.price}</b>

                                  </td>
                                </tr>
                              ))
                            }
                          </div>
                        )
                      ))} */}
                                            {data.additionalMembers &&
                                                data.additionalMembers.map((member: any) =>
                                                    member.ccpackages && member.ccpackages.length > 0 ? (
                                                        <>
                                                            <b key={member.id} style={{ margin: "20px 10px" }}>
                                                                {member.customer_name} - {member.customer_age}y/{member.customer_gender.charAt(0).toUpperCase()}
                                                            </b>
                                                            {member.ccpackages.map((pack: any) => (
                                                                <tr
                                                                    key={pack.code}
                                                                    style={{
                                                                        backgroundColor: "aliceblue",
                                                                        fontFamily: "Helvetica",
                                                                    }}
                                                                >
                                                                    <td
                                                                        style={{
                                                                            fontFamily: "Helvetica",
                                                                            padding: ".6rem",
                                                                            paddingRight: "1.6rem",
                                                                        }}
                                                                    >
                                                                        {pack.code} - {pack.name}
                                                                    </td>
                                                                    <td
                                                                        style={{
                                                                            fontFamily: "Helvetica",
                                                                            padding: ".6rem",
                                                                            display: "flex",
                                                                            justifyContent: "end",
                                                                        }}
                                                                    >
                                                                        <b>₹{pack.price}</b>
                                                                    </td>
                                                                </tr>
                                                            ))}
                                                            <span style={{ margin: "20px 10px" }}>

                                                            </span>
                                                        </>
                                                    ) : null
                                                )}

                                            {/* {data.additionalMembers &&
                        data.additionalMembers?.map(
                          (member: any) =>
                            member.ccpackages &&
                            member.ccpackages.length > 0 &&

                            member.ccpackages.map((pack: any) => (
                              <tr
                                style={{
                                  backgroundColor: "#fff",
                                  fontFamily: "Helvetica",
                                }}
                              >
                                <td
                                  style={{
                                    fontFamily: "Helvetica",
                                    padding: ".6rem",
                                    paddingRight: "1.6rem",
                                  }}
                                >
                                  {pack.code} - {pack.name}
                                </td>
                                <td
                                  style={{
                                    fontFamily: "Helvetica",
                                    padding: ".6rem",
                                    display: "flex", justifyContent: "end"
                                  }}
                                >
                                  <b>₹{pack.price}</b>

                                </td>
                              </tr>
                            ))
                        )} */}

                                            <tr
                                                style={{
                                                    backgroundColor: "#f9f9f9",
                                                    fontFamily: "Helvetica",
                                                }}
                                            >
                                                <td
                                                    style={{
                                                        fontFamily: "Helvetica",
                                                        padding: ".6rem",
                                                        paddingRight: "1.6rem",
                                                    }}
                                                >
                                                    Total Package Amount
                                                </td>
                                                <td
                                                    style={{
                                                        fontFamily: "Helvetica",
                                                        padding: ".6rem",
                                                        display: "flex", justifyContent: "end"
                                                    }}
                                                > <b>₹{data?.total_price_package || ""}</b>

                                                </td>
                                            </tr>
                                            <tr
                                                style={{
                                                    backgroundColor: "#f9f9f9",
                                                    fontFamily: "Helvetica",
                                                }}
                                            >
                                                <td
                                                    style={{
                                                        fontFamily: "Helvetica",
                                                        padding: ".6rem",
                                                        paddingRight: "1.6rem",
                                                    }}
                                                >
                                                    Diagnostic Fees
                                                </td>
                                                <td
                                                    style={{
                                                        fontFamily: "Helvetica",
                                                        padding: ".6rem",
                                                        display: "flex", justifyContent: "end"
                                                    }}
                                                >
                                                    <b>₹{data?.diagnostic_fee_amount || "0"}</b>

                                                </td>
                                            </tr>
                                            {/* <tr
                        style={{
                          backgroundColor: "#f9f9f9",
                          fontFamily: "Helvetica",
                        }}
                      >
                        <td
                          style={{
                            fontFamily: "Helvetica",
                            padding: ".6rem",
                            paddingRight: "1.6rem",
                          }}
                        >
                          VIP Membership Discount
                        </td>
                        <td
                          style={{
                            fontFamily: "Helvetica",
                            padding: ".6rem",
                            display: "flex", justifyContent: "end"
                          }}
                        >
                          <b>₹{data?.counpon_discount || "0"}</b>
                        </td>
                      </tr> */}
                                        </tbody>
                                    </table>
                                    <hr style={{ fontFamily: "Helvetica" }} />
                                    <table
                                        className="invoiceSummaryTable"
                                        style={{
                                            borderCollapse: "collapse",
                                            fontFamily: "Helvetica",
                                            fontSize: "16px",
                                            marginTop: "1rem",
                                            textAlign: "left",
                                            width: "100%",
                                        }}
                                    >
                                        <tbody>
                                            <tr
                                                style={{
                                                    fontFamily: "Helvetica",
                                                }}
                                            >
                                                <td
                                                    style={{
                                                        fontFamily: "Helvetica",
                                                        padding: ".6rem",
                                                        paddingRight: "1.6rem",
                                                    }}
                                                >
                                                    <b>Grand Total</b>
                                                </td>
                                                <td
                                                    style={{
                                                        fontFamily: "Helvetica",
                                                        padding: ".6rem",
                                                        display: "flex",
                                                        justifyContent: "end"
                                                    }}
                                                >
                                                    <b>₹{data.totalPrice} </b>
                                                </td>
                                            </tr>
                                            <tr
                                                style={{
                                                    backgroundColor: "rgb(238 228 222 / 74%)",
                                                    fontFamily: "Helvetica",
                                                }}
                                            >
                                                <td
                                                    style={{
                                                        fontFamily: "Helvetica",
                                                        padding: ".6rem",
                                                        paddingRight: "1.6rem",
                                                    }}
                                                >
                                                    <b>Paid Amount</b>
                                                </td>
                                                {booking?.centre_address?.type === "postpaid" ? <td style={{
                                                    fontFamily: "Helvetica",
                                                    padding: ".6rem",
                                                    display: "flex",
                                                    justifyContent: "end"
                                                }}>0</td> : <td
                                                    style={{
                                                        fontFamily: "Helvetica",
                                                        padding: ".6rem",
                                                        display: "flex",
                                                        justifyContent: "end"
                                                    }}
                                                >
                                                    <b>₹{booking.due_amount > 0 ? 0 : data.totalPrice}</b>
                                                    {/* {Number(data?.due) > 0 ? 0 : Number(data?.finalPrice)} */}
                                                </td>}
                                            </tr>
                                        </tbody>
                                    </table>

                                    <div
                                        className="invoiceSummary"
                                        style={{
                                            fontFamily: "Helvetica",
                                            display: "flex",
                                            justifyContent: "space-between",
                                        }}
                                    >
                                        <div style={{ marginTop: "20px" }}>
                                            <strong style={{ fontFamily: "Helvetica" }}>
                                                Amount Chargeable (in words)
                                            </strong>
                                            <div style={{ fontFamily: "Helvetica" }}>
                                                <i style={{ fontFamily: "Helvetica" }}>
                                                    Rupees
                                                    {" " + price_in_words(data?.totalPrice) + " "}
                                                    Only
                                                </i>
                                            </div>
                                            <div
                                                className="blueColor"
                                                style={{
                                                    color: "#11406b",
                                                    fontFamily: "Helvetica",
                                                    fontSize: "19px",
                                                }}

                                            >
                                                Company's PAN No.{" "}
                                                <span style={{ fontFamily: "Helvetica" }}>
                                                    AAKCR7631M
                                                </span>
                                            </div>
                                            {
                                                cghsclient && <div
                                                    className="blueColor"
                                                    style={{
                                                        color: "#11406b",
                                                        fontFamily: "Helvetica",
                                                        fontSize: "19px",
                                                    }}

                                                >
                                                    Company's GST No.{" "}
                                                    <span style={{ fontFamily: "Helvetica" }}>
                                                        09AAKCR7631M1ZP
                                                    </span>
                                                </div>
                                            }
                                        </div>



                                        <div
                                            className="paymentSummary"
                                            style={{
                                                float: "right",
                                                width: "50%",
                                                marginTop: "20px",
                                            }}
                                        >
                                            <strong
                                                style={{ fontFamily: "Helvetica", fontSize: "medium", display: "flex", justifyContent: "end" }}
                                            >
                                                Payment Mode Summary
                                            </strong>
                                            <table
                                                className="invoiceSummaryTable"
                                                style={{
                                                    borderCollapse: "collapse",
                                                    fontFamily: "Helvetica",
                                                    fontSize: "16px",
                                                    marginTop: "1rem",
                                                    textAlign: "left",
                                                    width: "100%",
                                                }}
                                            >
                                                <tbody>
                                                    <tr
                                                        style={{
                                                            backgroundColor: "rgb(238 228 222 / 74%)",
                                                            fontFamily: "Helvetica",
                                                        }}
                                                    >
                                                        <td
                                                            style={{
                                                                fontFamily: "Helvetica",
                                                                padding: ".6rem",
                                                                paddingRight: "1.6rem",
                                                            }}
                                                        >
                                                            Payment Date
                                                        </td>
                                                        <td
                                                            style={{
                                                                fontFamily: "Helvetica",
                                                                padding: ".6rem",
                                                                paddingRight: "1.6rem",
                                                            }}
                                                        >
                                                            Payment Mode
                                                        </td>
                                                        <td
                                                            style={{
                                                                fontFamily: "Helvetica",
                                                                padding: ".6rem",
                                                            }}
                                                        >
                                                            Amount
                                                        </td>
                                                    </tr>

                                                    <tr
                                                        style={{
                                                            backgroundColor: "#f9f9f9",
                                                            fontFamily: "Helvetica",
                                                        }}
                                                    >
                                                        <td
                                                            style={{
                                                                fontFamily: "Helvetica",
                                                                padding: ".6rem",
                                                                paddingRight: "1.6rem",
                                                            }}
                                                        >
                                                            {moment(booking?.created_at).format(
                                                                "DD MMM,YYYY"
                                                            )}
                                                        </td>
                                                        <td
                                                            style={{
                                                                fontFamily: "Helvetica",
                                                                padding: ".6rem",
                                                                paddingRight: "1.6rem",
                                                            }}
                                                        >
                                                            {data?.paymentMode === "online" ? "Online" : data?.paymentMode}
                                                        </td>
                                                        {booking?.centre_address?.type === "postpaid" ? <td
                                                            style={{
                                                                fontFamily: "Helvetica",
                                                                padding: ".6rem",
                                                            }}
                                                        >0</td> : <td
                                                            style={{
                                                                fontFamily: "Helvetica",
                                                                padding: ".6rem",
                                                            }}
                                                        >

                                                            ₹{booking?.due_amount > 0 ? 0 : data?.totalPrice}

                                                        </td>}
                                                    </tr>

                                                </tbody>
                                            </table>
                                            <hr style={{ fontFamily: "Helvetica" }} />
                                        </div>

                                    </div>

                                    <div
                                        className="invoiceNotes"
                                        style={{
                                            clear: "left",
                                            backgroundColor: "#fbfbfb",
                                            fontFamily: "Helvetica",
                                            fontSize: "12px",
                                            lineHeight: "1.4",
                                            marginBottom: "0rem",
                                            marginTop: "-0.4rem",
                                            padding: ".5rem",
                                        }}
                                    >
                                        <strong style={{ fontFamily: "Helvetica" }}>
                                            Important Notes:
                                        </strong>
                                        <ul style={{ fontFamily: "Helvetica" }}>
                                            <li style={{ fontFamily: "Helvetica" }}>
                                                This invoice can be used for tax exemption under section
                                                80-D (Preventive Health Checkup)
                                            </li>
                                            <li style={{ fontFamily: "Helvetica" }}>
                                                Reports sent on registered mail ID according to the
                                                respective TAT and can also be downloaded through
                                                Redcliffe Labs Application
                                            </li>
                                            <li style={{ fontFamily: "Helvetica" }}>
                                                All dispute / claims concerning to reports are subject
                                                to the courts of Delhi only
                                            </li>
                                            <li style={{ fontFamily: "Helvetica" }}>
                                                Redcliffe Labs assumes no liability towards any delays
                                                beyond its control
                                            </li>
                                            <li style={{ fontFamily: "Helvetica" }}>
                                                It is recommended that you consult your treating
                                                Doctor/Physician before choosing any treatment based on
                                                your report
                                            </li>
                                            <li style={{ fontFamily: "Helvetica" }}>
                                                Maximum liability of the Company shall not exceed the
                                                amount charged by the Company for the services availed
                                            </li>
                                            <li style={{ fontFamily: "Helvetica" }}>
                                                This is a computer generated receipt and does not
                                                require signature/stamp
                                            </li>
                                        </ul>
                                    </div>
                                    {booking?.report_status === "consolidate" && (
                                        <div className="rating-container">
                                            <div className="rating-layout">
                                                <div className="rating-left">
                                                    <div className="rating-title">
                                                        How likely are you to recommend Redcliffe Labs to your family & friends
                                                    </div>
                                                    <div className="rating-scale">
                                                        {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((score) => {
                                                            const band =
                                                                score <= 6 ? "detractor" : score <= 8 ? "passive" : "promoter";
                                                            return (
                                                                <a
                                                                    key={score}
                                                                    className={`rating-pill ${band}`}
                                                                    target="_blank"
                                                                    rel="noreferrer"
                                                                    href={url(score)}
                                                                >
                                                                    {score}
                                                                </a>
                                                            );
                                                        })}
                                                    </div>
                                                    <div className="rating-faces">
                                                        {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((score) => {
                                                            const band =
                                                                score <= 6 ? "detractor" : score <= 8 ? "passive" : "promoter";
                                                            const faceSrc =
                                                                score <= 6
                                                                    ? "https://static-redcliffelabs.s3.amazonaws.com/media/gallary-file/None/4ee21069-ca40-4085-aa1e-05951d7c1f8f.png"
                                                                    : score <= 8
                                                                        ? "https://static-redcliffelabs.s3.amazonaws.com/media/gallary-file/None/bcf5896c-7d78-40ce-872e-adc431d07a0e.png"
                                                                        : "https://static-redcliffelabs.s3.amazonaws.com/media/gallary-file/None/0e657017-8575-4d8c-a2cc-59da764088a0.png";
                                                            return (
                                                                <span key={score} className={`rating-face ${band}`}>
                                                                    <img className="rating-face-icon" src={faceSrc} alt={band} />
                                                                </span>
                                                            );
                                                        })}
                                                    </div>
                                                    <div className="rating-bar">
                                                        <span className="segment detractor" />
                                                        <span className="segment passive" />
                                                        <span className="segment promoter" />
                                                    </div>
                                                </div>
                                                <div className="rating-right">
                                                    <div className="qr-card">
                                                        <div className="qr-title">How Was Your Experience</div>
                                                        <div className="qr-body">
                                                            <div className="scan-stack">
                                                                <img
                                                                    className="scan-icon"
                                                                    src="https://static-redcliffelabs.s3.amazonaws.com/media/gallary-file/None/67dea106-45c6-4ee5-925e-a9310fe5f371.png"
                                                                    alt="Scanner"
                                                                />
                                                                {/* <div className="scan-badge">SCAN ME!</div> */}
                                                            </div>
                                                            <div className="qr-code">
                                                                {/* @ts-ignore */}
                                                                <QRCode
                                                                    value={`https://redcliffelabs.com/bookingfeedback?type=cc_booking_english&booking_id=${data?.bId}&uuid=${data?.uuid}`}
                                                                    size={92}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                </div>

                                 {!userDetails?.profile?.user_types?.includes("MEDICENTER_CC")&&<div className="pml-page-footer">
                                    <div
                                        className="invoiceFooter"
                                        style={{
                                            backgroundColor: "rgb(14, 63, 108)",
                                            color: "white",
                                            fontFamily: "Helvetica",
                                            fontSize: "22px",
                                            padding: "0.5rem",
                                            marginBottom: "20px",
                                            // marginTop: "38%",
                                            // marginBottom:"20%",
                                        }}
                                    >
                                        {booking?.lab_data?.footer_text ? (
                                            <div
                                                className="invoiceFooterItem"
                                                style={{
                                                    width: "100%",
                                                    alignItems: "center",
                                                    fontFamily: "Helvetica",
                                                    textAlign: "center",
                                                }}
                                            >
                                                <pre
                                                    style={{
                                                        color: "#e2124f",
                                                        fontWeight: 700,
                                                        fontFamily: "Helvetica",
                                                        fontSize: "25px",
                                                    }}
                                                >
                                                    {booking?.lab_data?.footer_text}
                                                </pre>
                                            </div>
                                        ) : (
                                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                                <div
                                                    className="invoiceFooterItem"
                                                    style={{
                                                        display: "flex",
                                                        gap: "5px"
                                                    }}
                                                >
                                                    <PhoneIcon style={{ width: "20px", margin: "2px" }} />
                                                    <span style={{ color: "white", fontWeight: 700 }}>

                                                        &nbsp;928-909-0609
                                                    </span>
                                                </div>
                                                <div
                                                    className="invoiceFooterItem"
                                                    style={{
                                                        display: "flex",
                                                        gap: "5px",
                                                    }}
                                                >
                                                    <EmailIcon style={{ width: "20px", margin: "2px" }} />
                                                    <span style={{ color: "white", fontWeight: 700 }}>
                                                        &nbsp;ccsupport@redcliffelabs.com
                                                    </span>
                                                </div>
                                                <div
                                                    className="invoiceFooterItem"
                                                    style={{
                                                        display: "flex",
                                                        gap: "5px"
                                                    }}
                                                >
                                                    <LanguageIcon style={{ width: "20px", margin: "2px" }} />
                                                    <span style={{ color: "white", fontWeight: 700 }}>
                                                        &nbsp;www.redcliffelabs.com
                                                    </span>
                                                </div>
                                            </div>
                                        )}
                                    </div>

                                </div>}

                            </div>
                            {/* <div className="page2">.</div> */}
                        </div>
                    )}
                </div>

            </div>
        </Modal>
    );
};
const mapStateToProps = (state: any) => ({
    booking: state.OffLineSupporteReducer.booking,
    invoiceLoader: state.OffLineSupporteReducer.bookingIdLoader,
    centerInfo: state.OffLineSupporteReducer.centerInfo,
    userDetails: state.OffLineSupporteReducer.userDetails,
});

export default connect(mapStateToProps, {
    getBookingById,
    getUserDetails
})(InvoiceTemplate);
